// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__DJZVJ","loaderOuter":"PageOverlayLoader_loaderOuter__24pES"};